import React, { useState, useEffect, useRef, useCallback } from "react";
import Image from "../fragments/Image";
import GravityForm from "react-gravity-form";

const PageContact = ({ block, post }) => {

	if (!block) return null;

	return (
		<div className="c-page__block c-page__block--contact">
			<div className="c-contact">
				<div className="l-grid">
					<div className="l-grid__col l-grid__col--m-4-12 l-grid__col--l-3-12">
						<div className="c-contact__text">
							<h3 className="c-paragraph c-paragraph--medium">Contact</h3>
							<div className="c-contact__text__content scope-text">
								{post.ftr_address &&
									<p dangerouslySetInnerHTML={{ __html: post.ftr_address }}></p>
								}
								<p>
									{post.ftr_phone && post.ftr_phone_url &&
										<><a href={"tel:" + post.ftr_phone_url}>{post.ftr_phone}</a><br /></>
									}
									{post.ftr_email &&
										<a href={"mailto:" + post.ftr_email}>{post.ftr_email}</a>
									}
								</p>
							</div>
						</div>
					</div>
					<div className="l-grid__col l-grid__col--m-6-12 l-grid__col--m-push-2-12 l-grid__col--l-6-12 l-grid__col--l-push-3-12">
						<div className="c-contact__form">
							<div className="scope-form">
								{block.form_id && 
									<GravityForm
										backendUrl={document.location.origin + '/wp-json/tenet/v1/form'}
										formID={block.form_id}
									/>
								}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default PageContact;
